import { z } from 'zod';
export const TrafficSourcesSchema = z.record(z.string(), z.number());
/** Base object (before cross-field refine) — use `.shape` for per-field validators. */ export const VisitorsCountriesFieldsSchema = z.object({
    data: z.record(z.string(), z.number()),
    startDate: z.string().nullish(),
    endDate: z.string().nullish()
});
export const VisitorsCountriesSchema = VisitorsCountriesFieldsSchema.refine((data)=>{
    var _data_startDate, _data_endDate;
    const start = (_data_startDate = data.startDate) == null ? void 0 : _data_startDate.trim();
    const end = (_data_endDate = data.endDate) == null ? void 0 : _data_endDate.trim();
    if (!start || !end) return true;
    return start <= end;
}, {
    message: 'End date must be on or after start date',
    path: [
        'endDate'
    ]
});
export const MonthlyVisitsSchema = z.record(z.string(), z.number());
/**
 * Per-month SimilarWeb arrays kept verbatim so an ongoing run can feed them back
 * as `previousData` and fetch only the months it's missing (BAL-7743). Snake-case
 * keys/elements mirror what the SimilarWeb activities produce and consume — do not
 * rename, or the vendor-side `getDates`/`combineDataAndTrim` merge stops matching.
 */ export const TrafficRawDataSchema = z.object({
    monthly_visits: z.array(z.object({
        date: z.string(),
        visits: z.number()
    })),
    pages_per_visit: z.array(z.object({
        date: z.string(),
        pages_per_visit: z.number()
    })),
    time_on_site: z.array(z.object({
        date: z.string(),
        average_visit_duration: z.number()
    })),
    bounce_rate: z.array(z.object({
        date: z.string(),
        bounce_rate: z.number()
    }))
});
export const TrafficAnalysisSchema = z.object({
    bounceRate: z.number().nullish(),
    timeOnSite: z.number().nullish(),
    pagesPerVisit: z.number().nullish(),
    sources: TrafficSourcesSchema.nullish(),
    countries: VisitorsCountriesSchema.nullish(),
    monthlyVisits: MonthlyVisitsSchema.nullish(),
    // BAL-7743: verbatim per-month vendor arrays for incremental re-fetch.
    rawData: TrafficRawDataSchema.nullish(),
    // BAL-7743: `YYYY-MM` of the complete month this SimilarWeb/WHOIS data was
    // fetched for. Ongoing runs copy stable vendor data forward until this month
    // rolls over instead of re-fetching every run.
    vendorDataAsOf: z.string().nullish(),
    // BAL-5661: `YYYY-MM` the top-3 `countries` geo data was fetched for. Geo is on a
    // 6-month cycle (not monthly), so it's copied forward until this is 6+ months old.
    // Absent ⇒ legacy top-1 data ⇒ treated as invalid and re-fetched on the next run.
    visitorsCountriesAsOf: z.string().nullish()
}).meta({
    id: 'TrafficAnalysis'
});

//# sourceMappingURL=traffic-analysis.schema.js.map